export const GET_ALL_USERS         = "get_all_users";
export const GET_USERS_BY_ID       = "get_user_by_id";
export const REGISTER_USERS        = "register_users";
export const UPDATE_USER           = "update_user";
export const SAVE_PATIENT          = "save_patient";
export const GET_PATIENTS          = "get_patients";
export const FIND_PATIENT          = "find_patient";
export const UPDATE_PATIENT        = "update_patient";
export const FILTER_PATIENT_BY_TAG = "filter_patient_by_tag";
export const CREATE_NEW_CASE       = "create_new_case";
export const GET_ALL_CASE          = "get_all_case";
export const FIND_PATIENT_CASE     = "find_patient_case";
export const UPDATE_PATIENT_CASE   = "update_patient_case";
export const CLOSE_PATIENT_CASE    = "close_patient_case";
export const GET_CATEGORIES        = "get_categories";
export const GET_DISTRIBUTION      = "get_distribution";
export const GET_REFERENCE         = "get_reference";
export const FIND_CLOSED_CASES     = "find_closed_cases";

export const ROOT_PATIENT_PERMISSIONS = [
  GET_PATIENTS,
  UPDATE_PATIENT,
  FILTER_PATIENT_BY_TAG,
  FIND_PATIENT,
  SAVE_PATIENT,
  CREATE_NEW_CASE,
  GET_ALL_CASE,
  FIND_PATIENT_CASE,
  UPDATE_PATIENT_CASE,
  CLOSE_PATIENT_CASE
];
export const ROOT_ADMIN_PERMISSIONS   = [
  GET_ALL_USERS,
  GET_USERS_BY_ID,
  REGISTER_USERS,
  UPDATE_USER
];

export const ROOT_SUBMISSION_PERMISSIONS = [
  FIND_CLOSED_CASES
];
